<script lang="ts">
  import { Button, Icon } from '../common';
  export let customClass = '';
  export let label = '';
</script>

<Button
  {customClass}
  heapAttr={{ action: 'action', subAction: 'back' }}
  variant="secondary"
  on:click
>
  <div class="flex items-center relative">
    <div class="absolute -left-2">
      <Icon name="chevron-left" size="medium" customClass="!mb-[4px]" />
    </div>
    {#if label}
      <p class="ml-4">{label}</p>
    {/if}
  </div>
</Button>
